import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Button } from "./ui/button";

const inp = "w-full h-9 bg-input border border-border rounded-sm px-2 text-sm outline-none focus:border-primary";
const lbl = "text-[11px] text-muted-foreground";

export function PaymentEditModal({ payment, users, plans, onOpenChange, onSaved }) {
  const [f, setF] = useState(null);
  useEffect(() => {
    if (!payment) { setF(null); return; }
    setF({
      user_id: payment.user_id || "", empresa: payment.empresa || "", valor: payment.valor ?? "",
      moeda: payment.moeda || "BRL", metodo: payment.metodo || "Pix", periodo_dias: payment.periodo_dias ?? 30,
      data: (payment.data || "").slice(0, 10), observacoes: payment.observacoes || "", plano_id: payment.plano_id || "",
    });
  }, [payment]);

  if (!payment || !f) return null;
  const save = async () => {
    try {
      await api.put(`/admin/payments/${payment.id}`, {
        ...f, valor: parseFloat(f.valor) || 0, periodo_dias: parseInt(f.periodo_dias) || 0,
        plano_id: f.plano_id || null, user_id: f.user_id || null,
      });
      toast.success("Pagamento atualizado (acesso recalculado)");
      onSaved?.();
      onOpenChange(false);
    } catch (e) { toast.error(e.response?.data?.detail || "Falha ao salvar"); }
  };

  return (
    <Dialog open={!!payment} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg" data-testid="payment-edit-modal">
        <DialogHeader><DialogTitle className="font-display">Editar pagamento</DialogTitle></DialogHeader>
        <div className="space-y-2.5">
          <div><label className={lbl}>Usuário</label><select className={inp} value={f.user_id} onChange={(e) => setF({ ...f, user_id: e.target.value })} data-testid="edit-pay-user"><option value="">— sem vínculo —</option>{users.map((u) => <option key={u.user_id} value={u.user_id}>{u.name} ({u.email})</option>)}</select></div>
          <div><label className={lbl}>Plano</label><select className={inp} value={f.plano_id} onChange={(e) => { const pl = plans.find((p) => p.id === e.target.value); setF({ ...f, plano_id: e.target.value, ...(pl ? { valor: String(pl.preco), moeda: pl.moeda } : {}) }); }} data-testid="edit-pay-plano"><option value="">— sem plano —</option>{plans.map((p) => <option key={p.id} value={p.id}>{p.nome}</option>)}</select></div>
          <div className="grid grid-cols-2 gap-2">
            <div><label className={lbl}>Valor</label><input type="number" step="0.01" className={inp} value={f.valor} onChange={(e) => setF({ ...f, valor: e.target.value })} data-testid="edit-pay-valor" /></div>
            <div><label className={lbl}>Moeda</label><select className={inp} value={f.moeda} onChange={(e) => setF({ ...f, moeda: e.target.value })}><option>BRL</option><option>USD</option><option>EUR</option></select></div>
          </div>
          <div className="grid grid-cols-2 gap-2">
            <div><label className={lbl}>Método</label><select className={inp} value={f.metodo} onChange={(e) => setF({ ...f, metodo: e.target.value })}><option>Pix</option><option>Cartão</option><option>Boleto</option><option>Transferência</option></select></div>
            <div><label className={lbl}>Validade (dias)</label><input type="number" className={inp} value={f.periodo_dias} onChange={(e) => setF({ ...f, periodo_dias: e.target.value })} data-testid="edit-pay-periodo" /></div>
          </div>
          <div><label className={lbl}>Empresa</label><input className={inp} value={f.empresa} onChange={(e) => setF({ ...f, empresa: e.target.value })} /></div>
          <div><label className={lbl}>Data</label><input type="date" className={inp} value={f.data} onChange={(e) => setF({ ...f, data: e.target.value })} /></div>
          <div><label className={lbl}>Observações</label><input className={inp} value={f.observacoes} onChange={(e) => setF({ ...f, observacoes: e.target.value })} /></div>
          <Button className="w-full rounded-sm h-9" onClick={save} data-testid="edit-pay-save">Salvar alterações</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
